// ** React Imports
import { Fragment, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// ** Third Party Components
import classnames from 'classnames'

// ** Store & Actions
import { useSelector, useDispatch } from 'react-redux'
import { handleContentWidth, handleMenuCollapsed, handleMenuHidden } from '@store/actions/layout'

// ** Styles
import 'animate.css/animate.css'
import styled, { css } from 'styled-components'
import { useFeatureGate } from '../../../../_hooks/useFeatureGate'

const VerticalLayout = styled.div`
  height: ${(props) => (props.$layout === 'BlankLayout' ? '100vh' : 'auto')};
  min-height: ${(props) => (props.$layout === 'BlankLayout' ? '100%' : 'auto')};

  ${(props) =>
    props.$layout === 'BlankLayout' &&
    css`
      @media (max-width: 1650px) {
        & > * {
          zoom: 0.75;
        }
      }
    `}
`

const LayoutWrapper = (props) => {
  // ** Props
  const { layout, children, appLayout, wrapperClass, transition, routeMeta } = props

  // ** Store Vars
  const dispatch = useDispatch()
  const location = useLocation()
  const store = useSelector((state) => state)
  const navbarStore = store.navbarReducer
  const contentWidth = store.layoutReducer.contentWidth

  const notificationBar = document.getElementById('schedule-notification')
  const isBannerVisible = useSelector(
    (state) => state.notificationContextReducer.scheduleNotificationContext?.isBannerVisible
  )
  const { value: centrali3_0 } = useFeatureGate('centrali3_0', false)

  const getFlexContainerStyle = (notificationBar) => {
    if (isBannerVisible) {
      const barHeight = notificationBar ? getComputedStyle(notificationBar).height : '0px'

      return {
        ...(isBannerVisible && { height: `calc(100% - (2px + ${barHeight}))` })
      }
    }
  }

  //** Vars
  const Tag = layout === 'HorizontalLayout' && !appLayout ? 'div' : Fragment
  const isWorkspace = location.pathname.includes('/workspace')

  // ** Clean Up Function
  const cleanUp = () => {
    if (routeMeta) {
      if (routeMeta.contentWidth) {
        dispatch(handleContentWidth('full'))
      }
      if (routeMeta.menuCollapsed) {
        // Don't expand menu on workspace routes
        if (!isWorkspace || routeMeta.menuCollapsed === true) {
          dispatch(handleMenuCollapsed(!routeMeta.menuCollapsed))
        }
      }
      if (routeMeta.menuHidden) {
        dispatch(handleMenuHidden(!routeMeta.menuHidden))
      }
    }
  }

  // ** ComponentDidMount
  useEffect(() => {
    if (routeMeta) {
      if (routeMeta.contentWidth) {
        dispatch(handleContentWidth(routeMeta.contentWidth))
      }
      if (routeMeta.menuCollapsed) {
        // Don't expand menu on workspace routes
        if (!isWorkspace || routeMeta.menuCollapsed === true) {
          dispatch(handleMenuCollapsed(routeMeta.menuCollapsed))
        }
      }
      if (routeMeta.menuHidden) {
        dispatch(handleMenuHidden(routeMeta.menuHidden))
      }
    }
    return () => cleanUp()
  }, [])

  return (
    <VerticalLayout
      $layout={layout}
      className={classnames('d-flex app-content content theme-surface-muted', {
        [wrapperClass]: wrapperClass,
        'show-overlay': navbarStore.query.length,
        'new-navbar': centrali3_0
      })}
      style={getFlexContainerStyle(notificationBar)}>
      {/* <div className="content-overlay"></div>
      <div className="header-navbar-shadow" /> */}
      <div className="w-100 content-height">
        <Tag
          {...(layout === 'HorizontalLayout' && !appLayout
            ? { className: classnames({ 'content-body': !appLayout }) }
            : {})}>
          {children}
        </Tag>
      </div>
    </VerticalLayout>
  )
}

export default LayoutWrapper
